export class DragAndDrop {
    constructor({
        draggableElement = 'tr'
    } = {}) {
        this.draggableElement = draggableElement;
        this.currentDragElement = null;
    }

    dragStart(event) {
        this.currentDragElement = this.$el.closest(this.draggableElement);
        this.currentDragElement.setAttribute('this.currentDragElement', true);

        if (event) {
            event.dataTransfer.effectAllowed = 'move';
        }
    }

    dragEnter(event) {
        event.preventDefault();
    }

    dragOver(event) {
        const element = this.$el.closest(this.draggableElement);

        if (this.currentDragElement === element) {
            event.preventDefault();

            return;
        }

        const draggedGroup = this.currentDragElement.dataset.dragGroup;
        const hoveredGroup = element.dataset.dragGroup;

        if (draggedGroup && hoveredGroup && draggedGroup !== hoveredGroup) {
            event.dataTransfer.dropEffect = 'none';

            return;
        }

        event.preventDefault();
        event.dataTransfer.dropEffect = 'move';

        const parent = element.parentNode;
        const siblings = Array.from(parent.children);
        const currentDragElementIndex = siblings.indexOf(this.currentDragElement);
        const elementIndex = siblings.indexOf(element);

        this.currentDragElement.style.opacity = 0;

        if (currentDragElementIndex < elementIndex) {
            parent.insertBefore(this.currentDragElement, element.nextSibling);

            return;
        }

        parent.insertBefore(this.currentDragElement, element);
    }

    drop({ onDropFinished = (ids) => {} }) {
        const element = this.$el.closest(this.draggableElement);
        const draggedGroup = this.currentDragElement.dataset.dragGroup;
        const hoveredGroup = element.dataset.dragGroup;

        if (draggedGroup && hoveredGroup && draggedGroup !== hoveredGroup) {
            return;
        }

        this.currentDragElement.removeAttribute('this.currentDragElement');

        const parent = this.currentDragElement.parentNode;

        parent.insertBefore(this.currentDragElement, element);

        const ids = Array.from(this.$root.querySelectorAll('[drag-item]'))
            .map(item => item.getAttribute('drag-item'));

        onDropFinished(ids);
    }

    dragEnd() {
        this.currentDragElement.removeAttribute('this.currentDragElement');
        this.currentDragElement.style.opacity = 1;
    }
}

export default function dragAndDrop(options = {}) {
    return new DragAndDrop(options);
}